<template>
  <div class="online_boosters_chip" :class="currentGameSlug">
    <div class="online_boosters"></div>
    <h4 class="medium-s font-family-2">
      <span v-if="fake_counter">{{ boosterCount }}</span>

      <span v-else>{{ response?.data?.boosters_online || 0 }}</span>
      {{ $t("missed.boosters_online") }}
    </h4>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onBeforeUnmount } from "vue";
import Cookies from "js-cookie";

const props = defineProps({
  fake_counter: {
    default: false,
  },
});
const fakeOnlineCount = ref(0);
const { currentGameSlug } = useGameComposable();

const boosterCount = computed(() => {
  if (props.fake_counter) return fakeOnlineCount.value;
  if (response?.data?.boosters_online) return response?.data?.boosters_online;
  return 0;
});

const {
  data: response,
  error,
  refresh,
} = await useApiFetch("/api/get-boosters-online", {
  method: "post",
  fetchKey: `get-online-booster-${currentGameSlug}`,
  body: {
    game_slug: currentGameSlug,
  },
  lazy: true,
});

// console.log(response.value);

onBeforeMount(() => {
  if (props.fake_counter) {
    fetchData();
    return;
  }
  window.Echo.channel("boosters-online").listen(".fetch", (e) => {
    refresh();
  });
});

onBeforeUnmount(() => {
  if (props.fake_counter) return;
  window.Echo.leave("boosters-online");
});

const fetchData = async () => {
  try {
    const minValue = 25;
    const maxValue = 50;

    let previousValue = Cookies.get("bm_c_set_r") || null;
    let randomValue = previousValue;

    if (!previousValue) {
      randomValue =
        Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    }

    const in1Hour = 1 / 24;
    Cookies.set("bm_c_set_r", randomValue, { expires: in1Hour });
    fakeOnlineCount.value = randomValue;
  } catch (error) {
    console.log(error);
  }
};
</script>
